import { render, staticRenderFns } from "./FilesAppSettingsShortcuts.vue?vue&type=template&id=a342e000"
import script from "./FilesAppSettingsShortcuts.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesAppSettingsShortcuts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports